import script from "./threeDspace.vue?vue&type=script&setup=true&lang=js"
export * from "./threeDspace.vue?vue&type=script&setup=true&lang=js"

import "./threeDspace.vue?vue&type=style&index=0&id=398004db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398004db"]])

export default __exports__